import { useState } from "react";

import { DEFAULT_INTERACTION_WEIGHTS } from "../constants";
import { SandboxEntityType } from "../types/entities";
import { InteractionType, WeightConfig } from "../types/interactions";

// const STORAGE_KEY = "sandbox_interaction_weights";

// function loadFromStorage(): WeightConfig {
//   try {
//     const raw = localStorage.getItem(STORAGE_KEY);
//     if (!raw) return structuredClone(DEFAULT_WEIGHTS);
//     // Merge with defaults so new interaction types added later are populated
//     const saved = JSON.parse(raw) as Partial<WeightConfig>;
//     const merged = structuredClone(DEFAULT_WEIGHTS);
//     for (const et of Object.keys(saved) as SandboxEntityType[]) {
//       if (merged[et] && saved[et]) {
//         Object.assign(merged[et], saved[et]);
//       }
//     }
//     return merged;
//   } catch {
//     return structuredClone(DEFAULT_WEIGHTS);
//   }
// }

const useSandboxWeights = () => {
  const [weights, setWeights] = useState<WeightConfig>(
    DEFAULT_INTERACTION_WEIGHTS,
  );

  const getWeight = (
    entityType: SandboxEntityType,
    interactionType: InteractionType,
  ): number => {
    return weights[entityType]?.[interactionType] ?? 0;
  };

  const updateWeight = (
    entityType: SandboxEntityType,
    interactionType: InteractionType,
    value: number,
  ): void => {
    setWeights((prev) => {
      const next = structuredClone(prev);
      next[entityType][interactionType] = Math.max(0, Math.min(1, value));
      // localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      return next;
    });
  };

  const resetToDefaults = (): void => {
    // const fresh = structuredClone(DEFAULT_WEIGHTS);
    // localStorage.setItem(STORAGE_KEY, JSON.stringify(fresh));
    setWeights(DEFAULT_INTERACTION_WEIGHTS);
  };

  const importWeights = (config: WeightConfig): void => {
    setWeights(structuredClone(config));
  };

  return { weights, getWeight, updateWeight, resetToDefaults, importWeights };
};

export default useSandboxWeights;
